import { logger } from '../../util/logger';
import { RepeatingTask } from '../../util/repeating_task';
import { Wall } from './wall';
import { WallItemBuilder } from './wall_item_builder';
export class RoomWall extends Wall {
    constructor(config) {
        super(config);
        // In case of app refresh, update item instead of throwing error if it already exists on wall
        this.addUserItem = this.addOrUpdateItemFromBuilder('buildUserWallItem');
        this.addCapabilities = this.addOrUpdateItemFromBuilder('buildCapabilities');
        this.addStreemshotRequest = this.addItemFromBuilder('buildStreemshotRequestItem');
        this.addStreemshotResponse = this.addItemFromBuilder('buildStreemshotResponseItem');
        this.addStreemshotRevision = this.addItemFromBuilder('buildStreemshotRevisionItem');
        this.addGeolocationRequest = this.addItemFromBuilder('buildGeolocationRequestWallItem');
        this.addGeolocationResponse = this.addItemFromBuilder('buildGeolocationResponseItem');
        this.addRoomItem = this.addItemFromBuilder('buildRoomWallItem');
        this.addCameraSubjectRequest = this.addItemFromBuilder('buildCameraSubjectRequestWallItem');
        this.addCameraSubjectResponse = this.addItemFromBuilder('buildCameraSubjectResponseWallItem');
        this.createDetection = this.addItemFromBuilder('buildCreateDetectionWallItem');
        this.updateDetection = this.addItemFromBuilder('buildUpdateDetectionWallItem');
        this.hideDetection = this.addItemFromBuilder('buildHideDetectionWallItem');
        this.addBookmark = this.addOrUpdateItemFromBuilder('buildBookmarkWallItem');
        this.addRoomOutcomeReport = this.addOrUpdateItemFromBuilder('buildRoomOutcomeReportWallItem');
        logger.info('Creating RoomWall...');
        this.builder = new WallItemBuilder(this.config.localDeviceId, this.config.localUserId);
        if (config.alive) {
            this.heartBeatTask = new RepeatingTask({
                taskName: RoomWall.HEART_BEAT_TASK_NAME,
                intervalMs: RoomWall.HEART_BEAT_INTERVAL_MS,
                errorThreshold: RoomWall.HEART_BEAT_ERROR_THRESHOLD,
                task: async () => {
                    let connectionState = this.wallSyncClient.wallSyncConnectionState;
                    if (this.tokenExpired === true) {
                        logger.warn(`RoomWall not sending heartbeat due to expired SyncClient token`);
                        return;
                    }
                    if (connectionState === 'disconnected') {
                        logger.warn(`RoomWall SyncClient not in connected state. Will try to reconnect. connectionState=${connectionState}`);
                        await this.wallSyncClient.reconnectIfNotConnected();
                        connectionState = this.wallSyncClient.wallSyncConnectionState;
                    }
                    if (connectionState !== 'connected') {
                        logger.warn(`RoomWall skipping the sending of heartbeat because SyncClient is not in 'connected' state; current connectionState=${connectionState}`);
                        return;
                    }
                    // hearbeat shouldn't be updated if there's no connection to the room
                    const heartbeatWallItem = this.builder.buildHeartbeatWallItem();
                    logger.debug(`RoomWall Sending Wall Heartbeat... wallItemId=${heartbeatWallItem.id} count=${heartbeatWallItem.heartbeat?.count}`);
                    this.addOrUpdate(heartbeatWallItem);
                },
                onError: err => logger.error(`taskName=${RoomWall.HEART_BEAT_TASK_NAME} roomId=${config.roomId}}participantId=${config.localUserId} encountered error=${err}`),
            });
        }
    }
    async connect() {
        logger.info(`RoomWall connecting...`);
        await super.connect();
        logger.info('starting RoomWall heartbeat task');
        await this.heartBeatTask?.start();
    }
    async disconnect() {
        logger.info('stopping RoomWall heartbeat task');
        this.heartBeatTask?.stop();
        logger.info(`RoomWall disconnecting...`);
        await super.disconnect();
        this.connectedSubscription?.unsubscribe();
    }
    addItemFromBuilder(buildMethod) {
        return (...args) => {
            // @ts-ignore This correctly spreads arguments
            const wallItem = this.builder[buildMethod](...args);
            this.add(wallItem);
            return wallItem.id;
        };
    }
    addOrUpdateItemFromBuilder(buildMethod) {
        return (...args) => {
            // @ts-ignore This correctly spreads arguments
            const wallItem = this.builder[buildMethod](...args);
            this.addOrUpdate(wallItem);
            return wallItem.id;
        };
    }
}
RoomWall.HEART_BEAT_TASK_NAME = 'RoomWall_HeartbeatTask';
RoomWall.HEART_BEAT_INTERVAL_MS = 10000; // 10 seconds
RoomWall.HEART_BEAT_ERROR_THRESHOLD = 30;
//# sourceMappingURL=room_wall.js.map